import { Blueprint } from '@/typings/printify/blueprint';
import { PrintProviderClass, PrintProvider } from '@/typings/printify/printProvider';
import api from './baseApi';

export const getShops = async (store: string): Promise<any> => {
    const response = await api.get(`printify/shops`, {
        params: {
            shop: store
        },
        cache: {
            maxAge: 60 * 60 * 1000
        }
    });
    return response.data;
};

export const getBlueprintsCatalog = async (store: string): Promise<Blueprint[]> => {
    const response = await api.get('printify/blueprints', {
        params: {
            shop: store
        },
        cache: {
            maxAge: 60 * 60 * 1000
        }
    });
    return response.data;
};

export const getBlueprint = async (blueprintId: number, store: string): Promise<Blueprint> => {
    const response = await api.get(`printify/blueprints/${blueprintId}`, {
        params: {
            shop: store
        },
        cache: {
            maxAge: 60 * 60 * 1000
        }
    });
    return response.data;
};

export const getAllPrintProviders = (store: string): Promise<PrintProviderClass[]> => {
    return api
        .get<PrintProviderClass[]>(`printify/print_providers`, {
            params: {
                shop: store
            },
            cache: {
                maxAge: 60 * 60 * 1000
            }
        })
        .then(({ data }) => data);
};

export const getPrintProviders = async (blueprintId: number, store: string): Promise<PrintProviderClass[]> => {
    const response = await api.get(`printify/blueprints/${blueprintId}/print_providers`, {
        params: {
            shop: store
        },
        cache: {
            maxAge: 60 * 60 * 1000
        }
    });
    return response.data;
};

export const getPrintProviderById = async (printProviderId: string): Promise<PrintProviderClass> => {
    const response = await api.get(`printify/print_providers/${printProviderId}`, {
        cache: {
            maxAge: 60 * 60 * 1000
        }
    });
    return response.data;
};

export const getPrintProviderVariants = async (
    blueprintId: number,
    printProviderId: number,
    store: string,
    showOutOfStock = false
): Promise<PrintProvider> => {
    const response = await api.get(`printify/blueprints/${blueprintId}/print_providers/${printProviderId}/variants`, {
        params: {
            shop: store,
            showOutOfStock: showOutOfStock
        },
        cache: {
            maxAge: 60 * 60 * 1000
        }
    });
    return response.data;
};
